import React from 'react'
import styles from './styles.module.scss'

const Loader = () => (
  <div className={styles.loader}>Loading...</div>
)

export default Loader
